var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRockSlideOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28857 4.28857L9.12286 9.12286L10.3314 17.5829L23.6257 29.6686L24.8343 35.7114H4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2514 18.7914C29.2538 18.7914 30.8772 17.1682 30.8772 15.1657C30.8772 13.1633 29.2538 11.54 27.2514 11.54C25.249 11.54 23.6257 13.1633 23.6257 15.1657C23.6257 17.1682 25.249 18.7914 27.2514 18.7914Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5029 30.8771C35.1703 30.8771 35.7115 30.3359 35.7115 29.6686C35.7115 29.0012 35.1703 28.46 34.5029 28.46C33.8355 28.46 33.2943 29.0012 33.2943 29.6686C33.2943 30.3359 33.8355 30.8771 34.5029 30.8771Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5828 6.70572C18.2503 6.70572 18.7914 6.16462 18.7914 5.49715C18.7914 4.82967 18.2503 4.28857 17.5828 4.28857C16.9154 4.28857 16.3743 4.82967 16.3743 5.49715C16.3743 6.16462 16.9154 6.70572 17.5828 6.70572Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRockSlideOutline);
export default __webpack_public_path__ + "static/media/icon_rock_slide_outline.0bb36998bab9b4faa56d0f8ebac6fad1.svg";
export { ForwardRef as ReactComponent };